import React, { useState } from 'react';
import { Icons } from '@citygross/icons';
import { formatPriceWithNoZero } from '@citygross/utils';
import { ToolTipDialog } from '../ToolTipDialog/ToolTipDialog.js';
import { CartSubTotalContainer, SubTotalLabel, ToolTipButton, Price } from './CartSubTotal.styles.js';
import { theme } from '@citygross/design-tokens';
var ECartSubTotalTypes;

(function (ECartSubTotalTypes) {
  ECartSubTotalTypes["items"] = "items";
  ECartSubTotalTypes["charges"] = "charges";
})(ECartSubTotalTypes || (ECartSubTotalTypes = {}));

var CartSubTotal = function CartSubTotal(_a) {
  var _b;

  var label = _a.label,
      value = _a.value,
      children = _a.children,
      info = _a.info,
      type = _a.type,
      fromPriceLabel = _a.fromPriceLabel,
      infoOnBottom = _a.infoOnBottom,
      _c = _a.priceColor,
      priceColor = _c === void 0 ? (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.darkest : _c;
  var formattedPrice = formatPriceWithNoZero(value);

  var _d = useState(false),
      infoOpen = _d[0],
      setInfoOpen = _d[1];

  var toggleInfoOpen = function toggleInfoOpen() {
    setInfoOpen(!infoOpen);
  };

  return info !== undefined ? React.createElement(CartSubTotalContainer, {
    type: type
  }, React.createElement(SubTotalLabel, null, label, children, React.createElement(ToolTipButton, {
    onClick: toggleInfoOpen
  }, React.createElement(Icons.Info, {
    height: 16,
    width: 16
  }))), React.createElement(Price, {
    priceColor: priceColor
  }, value !== 0 && !value || isNaN(value) ? '-' : "".concat(fromPriceLabel || '', " ").concat(formattedPrice, " kr")), infoOpen && React.createElement(ToolTipDialog, {
    onBottom: infoOnBottom,
    info: info,
    toggle: toggleInfoOpen
  })) : React.createElement(CartSubTotalContainer, {
    type: type
  }, React.createElement(SubTotalLabel, null, label, children), value !== undefined ? React.createElement(Price, {
    priceColor: priceColor
  }, formattedPrice, " kr") : null);
};

export { CartSubTotal, ECartSubTotalTypes };